import { Add20Filled, Add20Regular, ArrowRight20Regular, ArrowUpload20Regular, ChevronDown12Filled, ChevronDown12Regular, Clock20Filled, Clock20Regular, Cube20Filled, Cube20Regular, Dismiss16Filled, Dismiss16Regular, Document20Filled, Document20Regular, Folder20Filled, Folder20Regular, Grid20Filled, Grid20Regular, LayerDiagonal20Filled, LayerDiagonal20Regular, List20Filled, List20Regular, People20Filled, People20Regular, Person20Filled, Person20Regular, Star20Filled, Star20Regular, Tag20Filled, Tag20Regular, } from '@fluentui/react-icons';
export var getIconComponentFromName = function (name) {
    switch (name) {
        case 'List':
            return List20Regular;
        case 'ListActive':
            return List20Filled;
        case 'Grid':
            return Grid20Regular;
        case 'GridActive':
            return Grid20Filled;
        case 'UpArrow':
            return ArrowUpload20Regular;
        case 'ArrowRight':
            return ArrowRight20Regular;
        case 'CubeShape':
            return Cube20Regular;
        case 'CubeShapeActive':
            return Cube20Filled;
        case 'Clock':
            return Clock20Regular;
        case 'ClockActive':
            return Clock20Filled;
        case 'People':
            return People20Regular;
        case 'PeopleActive':
            return People20Filled;
        case 'FavoriteStar':
            return Star20Regular;
        case 'FavoriteStarActive':
            return Star20Filled;
        case 'Document':
            return Document20Regular;
        case 'DocumentActive':
            return Document20Filled;
        case 'Folder':
            return Folder20Regular;
        case 'FolderActive':
            return Folder20Filled;
        case 'Person':
            return Person20Regular;
        case 'PersonActive':
            return Person20Filled;
        case 'ChevronDown':
            return ChevronDown12Regular;
        case 'ChevronDownActive':
            return ChevronDown12Filled;
        case 'Add':
            return Add20Regular;
        case 'AddActive':
            return Add20Filled;
        case 'Dismiss':
            return Dismiss16Regular;
        case 'DismissActive':
            return Dismiss16Filled;
        case 'Tag':
            return Tag20Regular;
        case 'TagActive':
            return Tag20Filled;
        case 'Layer':
            return LayerDiagonal20Regular;
        case 'LayerActive':
            return LayerDiagonal20Filled;
        default:
            return Star20Regular;
    }
};
//# sourceMappingURL=getIconComponentFromName.js.map